import { Box, Stack, Typography } from '@mui/material';
import html2canvas from 'html2canvas';
import { useRef } from 'react';
import saveAs from 'file-saver';

interface Props {
  imgBarcode: string;
  BloodBarcodeImg: string;
}

const Barcored = (props: Props) => {
  const { imgBarcode, BloodBarcodeImg } = props;

  const divRef = useRef<HTMLDivElement>(null);

  const handleDownload = async (name: string) => {
    if (!divRef.current) return;

    try {
      const div = divRef.current;
      const canvas = await html2canvas(div, { scale: 2 });
      canvas.toBlob(blob => {
        if (blob !== null) {
          saveAs(blob, `${name} 바코드.png`);
        }
      });
    } catch (error) {
      console.error('Error converting div to image:', error);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'right',
          gap: '20px',
          marginTop: '30px',
        }}
      >
        <Stack direction="row">
          <Box
            sx={{
              border: '1px solid black',
              padding: '23px 10px 5px 10px',
              borderRight: 'none',
              borderRadius: '4px',
              borderTopRightRadius: '0px',
              borderBottomRightRadius: '0px',
            }}
          >
            <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
              환자 바코드
            </Typography>
          </Box>
          <div
            onClick={() => handleDownload('환자')}
            ref={divRef}
            style={{
              border: '1px solid black',
              padding: '13px 10px 5px 10px',
              marginRight: '10px',
              borderRadius: '4px',
              borderTopLeftRadius: '0px',
              borderBottomLeftRadius: '0px',
              cursor: 'pointer',
            }}
          >
            <img src={imgBarcode} alt="환자바코드" style={{ height: '40px' }} />
          </div>
        </Stack>
        <Stack direction="row">
          <Box
            sx={{
              border: '1px solid black',
              padding: '23px 10px 5px 10px',
              borderRight: 'none',
              borderRadius: '4px',
              borderTopRightRadius: '0px',
              borderBottomRightRadius: '0px',
            }}
          >
            <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
              수혈 바코드
            </Typography>
          </Box>
          <div
            onClick={() => handleDownload('수혈')}
            ref={divRef}
            style={{
              border: '1px solid black',
              padding: '13px 10px 5px 10px',
              marginRight: '10px',
              borderRadius: '4px',
              borderTopLeftRadius: '0px',
              borderBottomLeftRadius: '0px',
              cursor: 'pointer',
            }}
          >
            {BloodBarcodeImg ? (
              <img
                src={BloodBarcodeImg}
                alt="수혈바코드"
                style={{ height: '40px' }}
              />
            ) : (
              <Typography sx={{ fontSize: '12px', textAlign: 'center' }}>
                혈액번호 입력 후
                <br />
                생성버튼 클릭 시 바코드 생성
              </Typography>
            )}
          </div>
        </Stack>
      </Box>
    </>
  );
};

export default Barcored;
